import Blockly from 'blockly'
;('use strict')

// 媒体类别基础积木
Blockly.Blocks['gta_ai_media_item'] = {
  init: function() {
    this.appendDummyInput().appendField(
      new Blockly.FieldLabelSerializable(''),
      'NAME'
    )
    this.setOutput(true)
    this.setStyle('media_blocks')
    this.setTooltip('')
    this.setInputsInline(true)
    this.setHelpUrl('')
  },
}
Blockly.Python['gta_ai_media_item'] = function(block) {
  // TODO: Assemble Python into code variable.
  var code = '...'
  // TODO: Change ORDER_NONE to the correct strength.
  return [code, Blockly.Python.ORDER_NONE]
}

// 播放音频积木
Blockly.Blocks.play_audio = {
  init: function() {
    this.appendValueInput('NAME')
      .setCheck(null)
      .appendField('播放音频')
      .appendField('')
    this.setInputsInline(true)
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('media_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['PLAY_AUDIO_HELPURL'])
  },
}

Blockly.Python.play_audio = function(block) {
  var url = Blockly.Python.valueToCode(block, 'NAME', Blockly.Python.ORDER_NONE)

  //默认音量0.5
  return (
    'GTAFunAudio(url=' +
    url +
    ',attribute=' +
    "'play'" +
    ',volume=' +
    '0.2' +
    ')\n'
  )
}

// 停止播放音频积木
Blockly.Blocks.pause_audio = {
  init: function() {
    this.appendDummyInput().appendField('停止播放音频')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('media_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['PAUSE_AUDIO_HELPURL'])
  },
}
Blockly.Python.pause_audio = function() {
  return 'GTAFunAudio(attribute=' + "'pause'" + ',volume=' + '0.2' + ')\n'
}

// 将音量增加积木
Blockly.Blocks.volume_add_audio = {
  init: function() {
    this.appendDummyInput()
      .appendField('将音量增加')
      .appendField(new Blockly.FieldNumber(0, -100, 100), 'NAME')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('media_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['VOLUME_ADD_AUDIO_HELPURL'])
  },
}
Blockly.Python.volume_add_audio = function(block) {
  var number_num = block.getFieldValue('NAME')
  let volume = 0.2 + number_num / 100
  if (volume > 1) volume = 1
  else if (volume < 0) volume = 0
  return 'GTAFunAudio(attribute=' + "'play'" + ',volume=' + volume + ')\n'
}

// 将音量设为积木
Blockly.Blocks.volume_set_audio = {
  init: function() {
    this.appendDummyInput()
      .appendField('将音量设为')
      .appendField(new Blockly.FieldNumber(0, 0, 100), 'NAME')
    this.setPreviousStatement(true, null)
    this.setNextStatement(true, null)
    this.setStyle('media_blocks')
    this.setTooltip('')
    this.setHelpUrl(Blockly.Msg['VOLUME_SET_AUDIO_HELPURL'])
  },
}
Blockly.Python.volume_set_audio = function(block) {
  var number_num = block.getFieldValue('NAME')
  let volume = number_num / 100
  if (volume > 1) volume = 1
  else if (volume < 0) volume = 0
  return 'GTAFunAudio(attribute=' + "'play'" + ',volume=' + volume + ')\n'
}
